/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:07:36
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-14 11:01:04
 * @LastEditTime: 2021-06-30 18:53:12
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/TopConfigs/index.tsx
 */
import React from 'react';
import css from './css.less';

import { useSalesChannelMiniProgramLinkSet } from 'src/components/LinkModule/hooks';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';
import CloneBtn from './CloneButton';
import FloatingActionsBar from './FloatingActionsBar';
import HomePageSEOSetting from './HomePageSEOSetting';
import IconStyle from './IconStyle';
import MiniProgramInfo from './MiniInfo';
import MiniProgramShare from './MiniShare';

const TopConfigs = (props) => {
  const { isPrimaryLanguage, contentUuid, isNative } = props;
  const link = useSalesChannelMiniProgramLinkSet({ contentUuid });
  const type = useSalesChannelType();

  const _nativeRender = () => {
    if (isPrimaryLanguage) {
      return (
        <React.Fragment>
          {isNative && (
            <React.Fragment>
              <IconStyle /> <FloatingActionsBar linkSet={link} />
            </React.Fragment>
          )}{' '}
          <HomePageSEOSetting isPrimary={isPrimaryLanguage} />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <CloneBtn />
          {isNative && <FloatingActionsBar linkSet={link} />}
          <HomePageSEOSetting isPrimary={isPrimaryLanguage} />
        </React.Fragment>
      );
    }
  };
  const _miniProgramRender = () => {
    if (isPrimaryLanguage) {
      return (
        <React.Fragment>
          <IconStyle /> <FloatingActionsBar linkSet={link} />
          <MiniProgramShare />
          <MiniProgramInfo />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <CloneBtn /> <FloatingActionsBar linkSet={link} />
          <MiniProgramShare /> <MiniProgramInfo />
        </React.Fragment>
      );
    }
  };
  const renderContent = () => {
    if (type === ChannelType.MiniProgram) {
      return _miniProgramRender();
    }
    if (type === ChannelType.Website) {
      return _nativeRender();
    }
    return null;
  };

  //console.log('link', link);

  const body = renderContent();
  return <div className={css.container}>{body}</div>;
};
export default TopConfigs;
